export default __webpack_public_path__ + "static/media/template15.e6857b46.svg";